import {
  Component,
  DestroyRef,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { AnswerModuleService } from '@core/services/answer-module.service';
import { EditModeService } from '@core/services/edit-mode.service';
import { RedirectService } from '@core/services/redirect.service';
import { PAGE_TITLES, usePageTitle } from '@core/utils/page-title.util';
import { catchError, combineLatest, Observable } from 'rxjs';

@Component({
  selector: 'app-invitation',
  imports: [],
  templateUrl: './invitation.component.html',
  styleUrl: './invitation.component.scss',
})
export class InvitationComponent implements OnInit, OnDestroy {
  constructor(
    private answerModuleService: AnswerModuleService,
    private redirectService: RedirectService,
    private route: ActivatedRoute,
    private editModeService: EditModeService,
  ) {}

  @HostListener('window:popstate', ['$event'])
  onPopState() {
    history.pushState(null, '');
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.allowNavigation;
  }
  allowNavigation = false;
  private readonly destroyRef = inject(DestroyRef);
  private setPageTitle = usePageTitle();
  private beforeUnloadHandler = this.onBeforeUnload.bind(this);

  onBeforeUnload(event: Event): void {
    event.preventDefault();
  }

  ngOnDestroy(): void {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
  }

  ngOnInit(): void {
    this.setPageTitle(
      PAGE_TITLES.INVITATION.key,
      PAGE_TITLES.INVITATION.fallback,
    );

    this.editModeService.clearEditMode();

    window.addEventListener('beforeunload', this.beforeUnloadHandler);
  
    combineLatest([this.route.paramMap, this.route.queryParamMap])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([params, query]) => {
        const invitationId = params.get('invitationId');
        const questId = params.get('questId');
        const language = query.get('language');
        if (invitationId) {
          this.answerModuleService
            .getInvitationByInvitationId(invitationId)
            .pipe(
              takeUntilDestroyed(this.destroyRef),
              catchError(() => {
                this.allowNavigation = true;
                return [];
              }),
            )
            .subscribe((data) => {
              if (data.body) {
                this.allowNavigation = true;
                this.redirectService.redirectToView(data.body);
              }
            });
        }
        if (questId) {
          this.answerModuleService
            .getInvitationByQuestId(questId, language)
            .pipe(
              takeUntilDestroyed(this.destroyRef),
              catchError(() => {
                this.allowNavigation = true;
                return [];
              }),
            )
            .subscribe((data) => {
              if (data.body) {
                this.allowNavigation = true;
                this.redirectService.redirectToView(data.body);
              }
            });
        }
      });
  }
}
